import { defineComponent as _defineComponent } from 'vue'
import { Product } from '@/models/product_model';
import ExpiresCard from './ExpiresCard.vue';
import { FormatUtils } from '@/infra/utils/format.utils';

import PlusMinus from './PlusMinus.vue';
import { Icons } from '@/font-awesome';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartProductCard',
  props: {
    product: { type: Object, required: true },
    quantity: { type: Number, required: true }
  },
  emits: ["remove-from-cart", "set-amount", "add-to-cart"],
  setup(__props: any, { expose: __expose }) {
  __expose();






const __returned__ = { ExpiresCard, get FormatUtils() { return FormatUtils }, PlusMinus, get Icons() { return Icons }, get FontAwesomeIcon() { return FontAwesomeIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})